import { useLanguage, t } from "./i18n";
import React, {useRef} from "react";
import LanguageSwitcher from "./i18n/LanguageSwitcher";
import BottomNavigation from "./components/layout/BottomNavigation/BottomNavigation";
import { Routes, Route, useLocation } from "react-router-dom";
import useScrollHeader from "./hooks/useScrollHeader";
import {useAuth} from "./features/auth/context/AuthContext";
import "./components/layout/Header/ScrollHeader.css";
import { ToastContainer } from "react-toastify";
import Landing from "./pages/public/Landing/Landing";
import Login from "./pages/public/Login/Login";
import Register from "./pages/public/Register/Register";
import HomeDashboard from "./pages/account/HomeDashboard/HomeDashboard";
import Profile from "./pages/account/Profile/Profile";
import EditProfile from "./pages/account/EditProfile/EditProfile";
import CompleteProfile from "./pages/onboarding/CompleteProfile/CompleteProfile";
import NafathVerification from "./pages/onboarding/NafathVerification/NafathVerification";
import ListingsFeed from "./pages/listings/ListingsFeed/ListingsFeed";
import ListingDetails from "./pages/listings/ListingDetails/ListingDetails";
import MyPosts from "./pages/listings/MyPosts/MyPosts";
import Shortlist from "./pages/listings/Shortlist/Shortlist";
import CreateListing from "./pages/listings/CreateListing/CreateListing";
import EditListing from "./pages/listings/EditListing/EditListing";
import ProfileCompletionGuard from "./guards/ProfileCompletionGuard";
import CompleteProfileGuard from "./guards/CompleteProfileGuard";
import AuthGuard from "./guards/AuthGuard";
import PublicOnlyGuard from "./guards/PublicOnlyGuard";
import VerificationInfo from "./pages/public/VerificationInfo/VerificationInfo";
import TermsConditions from "./pages/public/TermsConditions/TermsConditions";
import PrivacyPolicy from "./pages/public/PrivacyPolicy/PrivacyPolicy";
import NotFound from "./pages/public/NotFound/NotFound";
import ScrollToTop from "./components/common/ScrollToTop/ScrollToTop";
import ROUTES from "./config/routes";
import "react-toastify/dist/ReactToastify.css";
export default function App() {
  const appRef = useRef(null);
  const {pathname} = useLocation();
  const {isAuthenticated} = useAuth();
  const header = useScrollHeader(appRef, pathname, isAuthenticated);
  const {
    language
  } = useLanguage();
  return <div ref={appRef} className={`bb-app${isAuthenticated ? " bb-app--authenticated" : ""}${header.hidden ? " bb-app--header-hidden" : ""}`} style={{'--bb-page-header-height': `${header.height}px`}} onFocusCapture={event => {
    if (event.target.closest('header, .bb-language-bar')) header.reveal();
  }}>
      <LanguageSwitcher />
      <ToastContainer position={language === "ar" ? "top-left" : "top-right"} rtl={language === "ar"} ariaLabel={t("Notifications")} autoClose={3000} />
      <ScrollToTop />

      <Routes>
        <Route path={ROUTES.ROOT} element={<PublicOnlyGuard>
              <Landing />
            </PublicOnlyGuard>} />


        <Route path={ROUTES.LOGIN} element={<PublicOnlyGuard>
              <Login />
            </PublicOnlyGuard>} />


        <Route path={ROUTES.REGISTER} element={<PublicOnlyGuard>
              <Register />
            </PublicOnlyGuard>} />


        <Route path={ROUTES.LISTINGS} element={<ListingsFeed />} />
        <Route path={ROUTES.LISTING_DETAILS} element={<ListingDetails />} />

        <Route path={ROUTES.HOME} element={<AuthGuard>
              <ProfileCompletionGuard>
                <HomeDashboard />
              </ProfileCompletionGuard>
            </AuthGuard>} />


        <Route path={ROUTES.CREATE_LISTING} element={<AuthGuard>
              <ProfileCompletionGuard>
                <CreateListing />
              </ProfileCompletionGuard>
            </AuthGuard>} />


        <Route path={ROUTES.EDIT_LISTING} element={<AuthGuard>
              <ProfileCompletionGuard>
                <EditListing />
              </ProfileCompletionGuard>
            </AuthGuard>} />


        <Route path={ROUTES.MY_LISTINGS} element={<AuthGuard>
              <ProfileCompletionGuard>
                <MyPosts />
              </ProfileCompletionGuard>
            </AuthGuard>} />


        <Route path={ROUTES.SHORTLIST} element={<AuthGuard>
              <ProfileCompletionGuard>
                <Shortlist />
              </ProfileCompletionGuard>
            </AuthGuard>} />


        <Route path={ROUTES.PROFILE} element={<AuthGuard>
              <ProfileCompletionGuard>
                <Profile />
              </ProfileCompletionGuard>
            </AuthGuard>} />


        <Route path={ROUTES.EDIT_PROFILE} element={<AuthGuard>
              <ProfileCompletionGuard>
                <EditProfile />
              </ProfileCompletionGuard>
            </AuthGuard>} />


        <Route path={ROUTES.COMPLETE_PROFILE} element={<AuthGuard>
              <CompleteProfileGuard>
                <CompleteProfile />
              </CompleteProfileGuard>
            </AuthGuard>} />


        <Route path={ROUTES.NAFATH_VERIFICATION} element={<AuthGuard>
              <NafathVerification />
            </AuthGuard>} />


        <Route path={ROUTES.VERIFICATION_INFO} element={<AuthGuard>
              <VerificationInfo />
            </AuthGuard>} />


        <Route path={ROUTES.PRIVACY_POLICY} element={<PrivacyPolicy />} />
        <Route path={ROUTES.TERMS_CONDITIONS} element={<TermsConditions />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      {isAuthenticated && <BottomNavigation />}
    </div>;
}
